import React from 'react'

const banner = props => <div className='image-cover-bg full-bock' style={{ background: `url("${props.img}")` }}>
</div>

export default banner